module.exports = __webpack_public_path__ + "img/img.48342981.png";